import type { ReactNode } from "react";
import { useRouter } from "next/router";
import { withAdsDisabled } from "src/components/Ads/withAdsDisabled";
import { Button } from "@memento/ui/Button";
import { useAuth } from "src/hooks/useAuth";
import { getUserLoginType } from "src/libs/user-lib";

type ForgotPasswordProps = {
  children: ReactNode;
};

export const ForgotPassword = withAdsDisabled(
  ({ children }: ForgotPasswordProps) => {
    const { isExternalUser, user } = useAuth();
    const router = useRouter();

    return (
      <section>
        <div className="my-5 flex items-center">
          <div className="w-1/4">
            <Button
              width="responsive"
              size="lg"
              variant="outline"
              onClick={() => router.back()}
              className="text-sm md:text-base"
            >
              Back
            </Button>
          </div>
          <div className="w-1/2 text-center font-futura text-xl font-medium text-gray-800 md:text-2xl lg:text-3xl">
            Reset Password
          </div>
          <div className="w-1/4" />
        </div>
        <div className="my-2 rounded-2xl border-2 border-gray-100 bg-white p-8">
          {isExternalUser ? (
            <section>
              <div className="my-5 font-futura text-2xl font-medium text-gray-800">
                This account is authenticated via {getUserLoginType(user)} and
                has no associated password.
              </div>
            </section>
          ) : (
            children
          )}
        </div>
      </section>
    );
  }
);
